import { render, staticRenderFns } from "./ProfileDemoReel.vue?vue&type=template&id=4fc4ed00"
import script from "./ProfileDemoReel.vue?vue&type=script&lang=ts"
export * from "./ProfileDemoReel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc4ed00')) {
      api.createRecord('4fc4ed00', component.options)
    } else {
      api.reload('4fc4ed00', component.options)
    }
    module.hot.accept("./ProfileDemoReel.vue?vue&type=template&id=4fc4ed00", function () {
      api.rerender('4fc4ed00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/ProfileDemoReel.vue"
export default component.exports